










































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { InteractionModel } from '@/app/shared/models';
import {
  PaymentInfoModel,
  VForm,
  ContactBillingModel,
} from '@/app/shared/models';
@Component({
  components: {},
})
export default class DialogBrcodeResend extends Vue {
  @Ref() private form!: VForm;
  @Prop(Boolean) readonly value!: boolean;

  private valueTab = '';
  private otherEmail = '';
  private EmailRequest = '';
  private emailsSelected: [] = [];
  private paymentInfo1: PaymentInfoModel = new PaymentInfoModel();
  private listPaymentInfo: PaymentInfoModel[] = [];

  private get refs() {
    return refsService;
  }

  private get rules() {
    return this.refs.static.rules;
  }

  private get contacts(): ContactBillingModel[] {
    return this.refs.modules.contract.customer.Contacts;
  }

  private async consultResendBRCode() {
    this.EmailRequest = '';
    if (this.emailsSelected) {
      this.EmailRequest += this.emailsSelected;
    }

    if (this.otherEmail != '') {
      if (this.EmailRequest != '') {
        this.EmailRequest += ';';
      }
      this.EmailRequest += this.otherEmail;
    }
    if (this.EmailRequest == '') {
      this.$toast.error(this.$t('toasts.validate_resend_email_bankslip'));
      return;
    }

    await this.refs.modules.contract
      .resendBRCode({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId: this.refs.modules.contract.installment.Id,
        listEmails: this.EmailRequest,
      })
      .then(() => {
        this.clearFields();
        this.$emit('close');
        this.$toast(this.$t('toasts.send_email_successfully'));
      })
      .catch((err) => this.$toast.error('ERROR ? ', err));

    if (!this.refs.modules.ticket.consultResendBRCode) {
      this.refs.modules.ticket.SET_CONSULT_RESEND_BRCODE(true);
      this.refs.modules.ticket.createInteraction(
        new InteractionModel(
          this.$t('action_code.ac20'),
          this.$t('action_desc.ad51') + ' - ' + this.valueTab
        )
      );
    }
  }
  private clearFields() {
    this.otherEmail = '';
    this.emailsSelected = [];
    this.valueTab = '';
    this.$emit('close');
  }
  private async resendEmailBRCode() {
    this.consultResendBRCode();
  }

  private get loadPaymentInfo() {
    const listEmails: string[] = [];

    const listContacts = this.contacts;
    if (listContacts) {
      listContacts.forEach((contact) => {
        if (
          this.refs.enums.ContactType[contact.Type] ==
          this.refs.enums.ContactType.Email.toString()
        ) {
          listEmails.push(contact.Value.toString());
        }
      });
    }

    const installmentId = this.refs.modules.contract.installment.Id;
    if (installmentId === undefined) return [];

    this.refs.modules.contract
      .loadPaymentInfoByInstallmentId({
        contractId: this.refs.modules.contract.contract.Id,
        installmentId,
      })
      .then(() => {
        this.refs.modules.contract.paymentInfo.forEach((paymentInfoAux) => {
          if (paymentInfoAux.Email) {
            listEmails.push(paymentInfoAux.Email);
          }
        });
      });
    return [...new Set(listEmails)];
  }
}
